import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { cardProviderRegexList, DestroyableBase, VoucherType } from 'osn-shared';
import {
  AdditionalInputType,
  EmailCollectorAdditionalControlDirective,
} from '../email-collector/email-collector-additional-control.directive';
import { AbstractEmailCollectorService } from '../email-collector/abstract-email-collector.service';
import { RedeemEmailCollectorService } from './redeem-email-collector.service';
import { RedeemCardViewModel } from './redeem-card.view-model';

@Component({
  selector: 'osn-shared-redeem-card',
  templateUrl: './redeem-card.component.html',
  styleUrls: ['./redeem-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: AbstractEmailCollectorService, useClass: RedeemEmailCollectorService }],
})
export class RedeemCardComponent extends DestroyableBase implements OnInit {
  @Input() public vm: RedeemCardViewModel;
  @Input() public type: AdditionalInputType;
  @Output() public submitted = new EventEmitter<void>();
  @Output() public loginError = new EventEmitter<void>();

  @ContentChild(EmailCollectorAdditionalControlDirective) public additionalControl: EmailCollectorAdditionalControlDirective;

  private readonly binNumberLength = 6;

  public voucherRegexp = /.+/;
  public binRegexp = /^[0-9]{6}$/;
  public showTickMark$ = this.redeemEmailCollectorService.showTickMark$;

  public voucherFormControl = new FormControl('');
  public binFormControl = new FormControl('');
  public validIcon: string;

  get passwordPlaceholderKey(): string {
    return this.redeemEmailCollectorService.isRegisteredCredential
      ? 'Redeem_Email_Collector_enter_password_placeholder'
      : 'Email_Collector_password_placeholder';
  }
  get promoError(): string {
    return this.voucherFormControl.getError('additionalInputError');
  }
  get binError(): string {
    return this.binFormControl.getError('additionalInputError');
  }
  public get isBinInputShown(): boolean {
    return this.vm.voucherType === VoucherType.CARD_NUMBER;
  }

  public constructor(private readonly redeemEmailCollectorService: AbstractEmailCollectorService, public elRef: ElementRef) {
    super();
  }

  public ngOnInit(): void {
    if (this.vm.defaultVoucherCode) {
      this.voucherFormControl.setValue(this.vm.defaultVoucherCode.toUpperCase());
      this.voucherFormControl.disable();
    }

    this.binFormControl.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((value: string) => {
      const matchingProvider = cardProviderRegexList.find((it) => value.match(it.startRegex));
      this.validIcon = matchingProvider ? matchingProvider.cardIcon : 'card-template';
    });
  }

  public onBinInput(event: any): void {
    const inputEvent = event as InputEvent;
    const currentValue = this.binFormControl.value;

    if (inputEvent.inputType === 'insertText' && currentValue.length > this.binNumberLength) {
      this.binFormControl.setValue(currentValue.slice(0, -1));
    }
  }

  public onSubmit(): void {
    this.submitted.emit();
  }

  public onLoginError(): void {
    this.loginError.emit();
  }
}
